import axios from 'utils/axios';

export const updateCallFactDuration = async (appointmentId: string): Promise<number> => {
  const result = await axios.get(`/api/v1/videochat/calldurations/${appointmentId}`)
  return result.data.data
}
